import { useParams, useNavigate } from "react-router-dom";
import { jewelleryProducts, category } from "../data/jewelleryData";
import "./CategoryPage.scss";

const CategoryPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  // Merge ALL PRODUCTS (Main + Bridal Category)
  const allProducts = [...jewelleryProducts, ...category];

  // Find Selected Product
  const selectedProduct = allProducts.find((item) => item.id.toString() === id);

  if (!selectedProduct) {
    return (
      <div className="category-page">
        <h2>Product Not Found</h2>
      </div>
    );
  }

  // Filter Related Products
  const relatedProducts = allProducts.filter(
    (item) =>
      item.category?.toLowerCase() ===
        selectedProduct.category?.toLowerCase() &&
      item.id !== selectedProduct.id
  );

  // Whatsapp Buy Button
  const handleWhatsappOrder = (product) => {
    const phoneNumber = "+917828551893";

    const message =
      `Hello, I want to buy this jewellery.\n` +
      `*Name:* ${product.name}\n` +
      `*Website:* https://www.swarnashringar.com\n` +
      `Please share more details.`;

    const encodedMessage = encodeURIComponent(message);

    window.open(
      `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodedMessage}`,
      "_blank"
    );
  };

  // Back Button
  const handleBack = () => {
    navigate("/Collections");
  };

  return (
    <div className="category-page">
      <h1>{selectedProduct.category}</h1>

      {/* SELECTED PRODUCT */}
      <div className="selected-product">

        {/* IMAGE-WRAPPER REMOVED */}
        <img src={selectedProduct.image} alt={selectedProduct.name} />

        <div className="category-overlay">
          <button
            className="buy-btn"
            onClick={() => handleWhatsappOrder(selectedProduct)}
          >
            Buy Now
          </button>

          <button className="back-btn" onClick={handleBack}>
            Back
          </button>
        </div>

        <p>{selectedProduct.name}</p>
      </div>

      {/* RELATED PRODUCTS */}
      <h2>More from this category</h2>

      <div className="related-grid">
        {relatedProducts.length > 0 ? (
          relatedProducts.map((item) => (
            <div className="related-card" key={item.id}>
              
              {/* IMAGE-WRAPPER REMOVED */}
              <img src={item.image} alt={item.name} />

              <div className="category-overlay">
                <button
                  className="buy-btn"
                  onClick={() => handleWhatsappOrder(item)}
                >
                  Buy Now
                </button>

                <button className="back-btn" onClick={handleBack}>
                  Back
                </button>
              </div>

              <p>{item.name}</p>
            </div>
          ))
        ) : (
          <h5>No more items in this category</h5>
        )}
      </div>
    </div>
  );
};

export default CategoryPage;
